import { Suspense, useMemo } from 'react';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { PROMOTION_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { PromoItemZmInstitutesPage } from '@/features/promotion/pages/PromoItemZmInstitutesPage';
import { promoZmListSearchSchema } from '@/features/promotion/types/promotion.types';
import { toPromoDrillSearch } from '@/features/promotion/utils/promotionFilters';
import { parsePositiveIdParams } from '@/utils/routeParams';

export const Route = createFileRoute('/_auth/promotion/adjustment/$promoItemId/$zmId')({
  beforeLoad: () => requirePermission(PROMOTION_PERMISSIONS.ADJUSTMENT_VIEW),
  parseParams: (rawParams) => {
    const params = parsePositiveIdParams(rawParams);
    if (params === null) throw notFound();
    return params;
  },
  validateSearch: promoZmListSearchSchema,
  component: function PromoItemZmInstitutesRoute() {
    const { promoItemId, zmId } = Route.useParams();
    const routeSearch = Route.useSearch();
    const zmSearch = useMemo(() => toPromoDrillSearch(routeSearch), [routeSearch]);
    const navigate = Route.useNavigate();
    return (
      <ErrorBoundary moduleName="Promotional Item Institutes">
        <Suspense fallback={<PageLoader />}>
          <PromoItemZmInstitutesPage
            unit="promotion"
            promoItemId={promoItemId}
            zmId={zmId}
            zmSearch={zmSearch}
            searchBox={{
              appliedText: routeSearch.q,
              onApply: (text) =>
                void navigate({ search: (previous) => ({ ...previous, q: text }), replace: true }),
            }}
          />
        </Suspense>
      </ErrorBoundary>
    );
  },
});
